import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from "react-redux";
import moment from 'moment';
import { logFazendaSincAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import DataTable from 'react-data-table-component';
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, CardHeader, Input } from 'reactstrap';

const RelatorioFazendaLogSinc = (props) => {

    const [term, setTerm] = useState('');

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(logFazendaSincAction.getLogFazendaSinc());
    }, []);

    const { logFazendaSinc } = props.logFazendaSinc;

    const columns = [
        {
            name: 'Nome da Fazenda',
            selector: row => (
                <Link target="_blank" to={{ pathname: `/fazenda/${row.idFazenda}` }}>
                    {row.fazenda.toUpperCase()}
                </Link>
            ),
            sortable: true
        },
        {
            name: 'Empresa',
            selector: row => `${row.empresa ? row.empresa : ''}`,
            sortable: true
        },
        {
            name: 'Dias Sem Sincronizar',
            selector: row => `${row.ultimaAlteracao != null ? row.dias : 'Ainda não sincronizou'}`,
            sortable: true
        },
        {
            name: 'Última Alteração',
            selector: row => `${row.ultimaAlteracao ? moment(row.ultimaAlteracao).format("DD/MM/YYYY HH:mm") : '-'}`,
            sortable: true
        }
    ];

    const handleChange = prop => event => {
        setTerm(event.target.value);
    };


    return (
        <div>
            <Card>
                <CardHeader>
                    <Row>
                        <Col md={8}>
                            <h6 className="left">Fazendas Por Data de Sincronismo</h6>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md={6} >
                            <Input
                                id="term"
                                label="term"
                                placeholder="Filtro"
                                value={term}
                                onChange={handleChange('term')}
                            />
                        </Col>
                    </Row>
                    <br />
                    <DataTable
                        title=""
                        columns={columns}
                        pagination={true}
                        striped={true}
                        noDataComponent="Sem registros para mostrar"
                        paginationComponentOptions={{ rowsPerPageText: 'Registros por página:', rangeSeparatorText: 'de', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'Tudo' }}
                        data={logFazendaSinc?.filter((item) => {
                            if (term === "") {
                                return item;
                            } else if (item.fazenda.toLowerCase().includes(term.toLowerCase())) {
                                return item;
                            }
                        })}
                    />
                    <Row>
                        <Col className="left" md="12" lg="12">
                            <span style={{ color: '#737373' }}>* Clique sobre o nome da Fazenda para abrir a tela de edição da mesma</span>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}


const mapStateToProps = (state) => {
    return state
};

const connectedRelatorioFazendaLogSincPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(RelatorioFazendaLogSinc));
export { connectedRelatorioFazendaLogSincPage as RelatorioFazendaLogSinc };